import { IClientAccount } from "./client-account.model";
import { ILocality } from "./locality.model";
import { IJobData } from "./job-data.model";
import { WorkDay } from "./work-day.model";
import { IApplicationQuestion } from "./application-question.model";
import { ApplicationType } from "./enumerations/application-type.model";

export interface IApplication {

  id?: number;
  typeOfApplication?: ApplicationType;
  clientAccount?: IClientAccount | null;
  fromDate?: string;
  toDate?: string;
  name?: string;
  localities?: ILocality[] | null;
  job?: IJobData;
  jobData?: IJobData | null;
  workDay?: WorkDay;
  description?: string;
  minimumRequirements?: string;
  vacancies?: number | null;
  applicationQuestions?: IApplicationQuestion[] | null;
  publishedDate?: string | null;
}

export const defaultValue: IApplication = {};
